export default {
  summary: {
    delivery: 'Levering: Gavekort som PDF via e-mail',
  },
};
